<template>
  <div class="modal">
    <div class="modal__bg" @click="close"></div>
    <div class="modal__body">
      <div v-if="modalName === 'add-member'">
        <h4 class="modal__header">
          Add New Member
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="close"
          />
        </h4>
        <AddNewMember />
      </div>
      <div v-if="modalName === 'add-company' || modalName === 'edit-company'">
        <h4 class="modal__header">
          <span v-if="modalName === 'add-company'">Add New Company</span>
          <span v-if="modalName === 'edit-company'">Edit Company</span>
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="close"
          />
        </h4>
        <AddNewCompany @close="close" />
      </div>
      <div v-if="modalName === 'add-event' || modalName === 'edit-event'">
        <h4 class="modal__header">
          <span v-if="modalName === 'add-event'">Add New Event</span>
          <span v-if="modalName === 'edit-event'">Edit Event</span>
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="close"
          />
        </h4>
        <AddNewEvent @close="close" />
      </div>
      <div v-if="modalName === 'report-bug'">
        <h4 class="modal__header">
          Report an Issue
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="close"
          />
        </h4>
        <ReportABug />
      </div>
      <div v-if="modalName === 'add-company-member'">
        <h4 class="modal__header">
          Add Members
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="close"
          />
        </h4>
        <AddCompanyMembers />
      </div>
      <div v-if="modalName === 'add-event-participant'">
        <h4 class="modal__header">
          Add Participants
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="close"
          />
        </h4>
        <AddEventParticipant />
      </div>
      <div v-if="modalName === 'book-a-member'">
        <h4 class="modal__header">
          Book existing member
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="close"
          />
        </h4>
        <BookAMember />
      </div>
    </div>
  </div>
</template>

<script>
import {
  AddNewMember,
  AddEventParticipant,
  AddNewCompany,
  AddNewEvent,
  ReportABug,
  AddCompanyMembers,
  BookAMember
} from "@/modules/admin/elements/forms";

export default {
  name: "Modal",
  components: {
    AddNewMember,
    AddNewCompany,
    AddNewEvent,
    AddCompanyMembers,
    ReportABug,
    AddEventParticipant,
    BookAMember
  },
  props: {
    backTo: String
  },
  destroyed() {
    document.body.style.overflow = "initial";
  },
  mounted() {
    document.body.style.overflow = "hidden";
    document.querySelector(".modal").style.top = `${window.scrollY}px`;
  },
  data() {
    return {
      modalName: ""
    };
  },
  created() {
    this.modalName = this.$route.params.name;
  },
  methods: {
    close() {
      if (this.backTo) {
        this.$router.push(this.backTo);
      } else {
        this.$router.back();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.h-0 {
  height: 0;
}
.modal {
  display: block;
  min-height: 100vh;
  left: 0;
  width: 100%;
  .row {
    width: inherit;
  }
  &__bg {
    background-color: black;
    height: 100%;
    left: 0;
    opacity: 0.5;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0;
  }

  &__body {
    animation: fade-in-up 0.25s ease-out forwards;
    background-color: white;
    border-radius: 5px;
    left: 50%;
    max-height: 600px;
    overflow: auto;
    padding: 40px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 650px;
    z-index: 1;
  }
  &__header {
    color: $gray-900;
    font-size: $font-size-base;
    margin-bottom: 40px;
    position: relative;
    img {
      cursor: pointer;
      top: 0;
      position: absolute;
      right: 0;
    }
  }
}

@keyframes fade-in-up {
  0% {
    opacity: 0;
    top: 44%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}
</style>
